import React, { useRef } from 'react'

interface FileInputProps {
  onFilePicked: (file: File) => Promise<void> | void
  accept?: string
  children?: React.ReactNode
  testId?: string
}

const FileInput = ({ onFilePicked, accept = '*/*', children, testId }: FileInputProps) => {

  const inputFileRef = useRef<HTMLInputElement>(null)

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.files?.[0] && await onFilePicked(e.target.files[0])
    e.target.value = ''
  }

  return (
    <>
      <input
        className="hidden"
        ref={inputFileRef}
        type="file"
        name="file"
        onChange={onChange}
        data-testid={testId}
        {...{ accept }}
      />
      <div onClick={() => inputFileRef.current?.click()}>
        {children}
      </div>
    </>
  )
}

export default FileInput
